<template>
    <div>
        <div class="header-view">
            <div style="font-size:20px;margin-top: 14px;">
                {{ $t('paymentConfirmation') }}
            </div>
        </div>
        <div style="position: fixed; top: 80px; width: 100%; z-index: 1060;">
            <div class="row">
                <div class="col-12 text-center d-flex justify-content-center">
                    <div class="receipt-summary text-center">
                        <div class="p-4">
                            <h5 class="mt-4">{{ $t('paymentAmount') }}</h5>
                            <h1>{{ parseFloat(docTotal).toFixed(2) }} ฿</h1>
                        </div>
                        <br>
                        <h5>{{ $t('PaymentMethod') }} : {{ $t('QRCode') }}</h5>
                    </div>
                </div>
                <div v-if="$i18n.locale == 'th'" class="col-12 text-center d-flex justify-content-center">
                    <div style="width: 80%;font-size: large;" class="mt-5 text-center">
                        โปรดตรวจสอบรายละเอียดการชำระเงิน<br>และคลิก 'ชำระเงิน' เพื่อดำเนินการ<br>ต่อไปยังหน้า {{
                    $t('QRCode') }}
                        <br>
                        <div class="mt-5 text-description">การชำระเงินของคุณได้รับการ<br>ประมวลผลอย่างปลอดภัยโดย
                            SilomPOS</div>
                    </div>
                </div>
                <div v-else class="col-12 text-center d-flex justify-content-center">
                    <div style="width: 80%;font-size: large;" class="mt-5 text-center">
                        Please review the details and <br> click 'Pay now'
                        <br>
                        <div class="mt-5 text-description">Your payment is securely processed by <br> Silom POS</div>
                    </div>
                </div>
            </div>
        </div>
        <QRPayment v-if="methodOption == 'qr'" :docTotal="docTotal"></QRPayment>
        <CreditCardPayment v-if="methodOption == 'credit'" :docTotal="docTotal"></CreditCardPayment>
    </div>
</template>

<script>
import QRPayment from '@/views/dine-in/payment/QRPayment.vue';
import CreditCardPayment from '@/views/dine-in/payment/CreditCardPayment.vue';
import payment from '@/services/payment';
import signed from '@/util/signed';
import { mapGetters } from 'vuex';
import poscrm from '@/services/poscrm'

export default {
    components: {
        QRPayment,
        CreditCardPayment,
    },
    data() {
        return {
            showQrModal: true,
            showCreditCardModal: false,
        };
    },
    computed: {
        ...mapGetters(['shopLineOA']),
        uid() {
            return `${localStorage.getItem('uid')}`;
        },
        shopObjectId() {
            return `${localStorage.getItem('shopObjectId')}`;
        },
        shop() {
            return this.shopLineOA.find(
                (detail) => detail.objectId === this.shopObjectId
            );
        },
        methodOption() {
            return this.$route.query.method;
        },
        docTotal() {
            return this.$route.query.docTotal;
        },
    },
    mounted() {
        this.intervalId = setInterval(this.getReceiptTransaction, 3000)
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
    },
    created() {
        localStorage.setItem('receiptObjectId', this.$route.query.objectId)
        this.getPKey();
    },
    methods: {
        async getReceiptTransaction() {
            let receiptObjectId = this.$route.query.objectId
            console.log('Check Receipt')
            try {
                await poscrm
                    .get('/api/v1.1/' + this.uid + '/Receipt/data/' + receiptObjectId)
                    .then((res) => {
                        let document = res?.data?.data?.document || {}
                        if (document.receiptStatus == 'A') {
                            clearInterval(this.intervalId);
                            this.$router.push(`/delivery/tracking?objectId=${document.objectId}&redirect=payment`)
                        }
                    }
                    )
            } catch (error) {
                throw new Error(error)
            }
        },
        getPKey() {
            let token = signed.sign();
            payment({
                method: 'get',
                url: "/embedded/v1.1/kbank/config/" + this.uid + "?shopObjectId=" + this.shopObjectId,
                headers: {
                    authorization: token,
                },
            }).then((res) => {
                localStorage.setItem("pkey", res.data.data.pkey);
                localStorage.setItem("mid", res.data.data.mid);
            });
        },
    },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.receipt-summary {
    width: 80%;
    padding-bottom: 70px;
    background-color: #eeeeee;
    border-radius: 5px;
    -webkit-mask-image: radial-gradient(circle at 50% 8px, transparent 8px, red 8.5px);
    -webkit-mask-position: 50% -8px;
    -webkit-mask-size: 16px 100%;
}

.header-view {
    background-color: #219b78;
    color: #ffffff;
    height: 60px;
    position: fixed;
    top: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 1060 !important;
}
</style>
